import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";
import {SportTeamSchemaModel} from "./sport-team-schema-model";
import {LocationSchemaModel} from "./location-schema-model";
import {SCHEMA_EVENT_STATUS} from "./consts";
import {GameImageRequestParams} from "../../../domain/partial-game/models/game-image-request-params";
import {OrganizerSchemaModel} from "./organizer-schema-model";

export class SportEventSchemaDataModel extends BaseSchemaDataModel {
  description: String;
  location: LocationSchemaModel;
  startDate: String;
  endDate: String;
  homeSportTeam: SportTeamSchemaModel;
  awaySportTeam: SportTeamSchemaModel;
  eventStatus: SCHEMA_EVENT_STATUS;
  logo: GameImageRequestParams;
  organizer: OrganizerSchemaModel;
  eventAttendanceMode: String;
}

export class SportEventSchemaModel extends BaseSchemaModel {
  model: SportEventSchemaDataModel

  constructor(model: SportEventSchemaModel) {
    super(SCHEMA_TYPE.sportsEvent, model.name, model.url);

    this.model = model;
  }

  get logoParams(): String {
    return this.model.logo ? `,"image": "${this.model.logo.toString()}"` : '';
  }

  get locationParams(): String {
    return this.model.location ? `,"location": [${this.model.location.toString()}]` : '';
  }

  get startDateParams(): String {
    return this.model.startDate ? `,"startDate": "${this.model.startDate}"` : '';
  }

  get endDateParams(): String {
    return this.model.endDate ? `,"endDate": "${this.model.endDate}"` : '';
  }

  get homeTeamParams(): String {
    return this.model.homeSportTeam ? `,"homeTeam": {${this.model.homeSportTeam.toString()}}` : '';
  }

  get awayTeamParams(): String {
    return this.model.awaySportTeam ? `,"awayTeam": {${this.model.awaySportTeam.toString()}}` : '';
  }

  get descriptionParams(): String {
    return this.model.description ? `,"description": ${JSON.stringify(this.model.description)}` : '';
  }
  get eventStatusParams(): String {
    return this.model.eventStatus ? `,"eventStatus": "${this.model.eventStatus}"` : '';
  }

  get organizerParams(): String {
    return this.model.organizer ? `,"organizer": {${this.model.organizer.toString()}}` : '';
  }

  get eventAttendanceModeParams(): String {
    return this.model.eventStatus ? `,"eventAttendanceMode": "${this.model.eventAttendanceMode}"` : '';
  }

  toString(): String {
    return `${super.toString()}${this.eventAttendanceModeParams}${this.organizerParams}${this.locationParams}${this.startDateParams}${this.endDateParams}${this.eventStatusParams}${this.descriptionParams}${this.logoParams}${this.homeTeamParams}${this.awayTeamParams}`;
  }
}
